import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { PROPERTY_OWNERSHIP_V2_API } from "../apiRoutes";

interface mutateProps {
  data: FieldValues;
  communityId: string;
}

const mutateAddPropertyOwner = async ({ data, communityId }: mutateProps) => {
  return await axiosAuth.post(`${PROPERTY_OWNERSHIP_V2_API(communityId)}`, data);
};

const useAddPropertyOwnerMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddPropertyOwner,
    ...queryParams,
  });

export default useAddPropertyOwnerMutation;
